import React, { useState } from 'react';
import { Modal } from "react-bootstrap";
import { Button, SvgIcon } from '@material-ui/core/';
import PlayVideoIcon from '../../../../icons/play-video.svg';
import PropTypes from 'prop-types';

function VideoModal(props) {
  return (
    <Modal show={props.show} onHide={props.onHide} onClose={props.onHide} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="embed-responsive embed-responsive-16by9">
        <iframe src={props.link} className="embed-responsive-item" title={props.title} />
      </Modal.Body>
    </Modal>
  )
}

export default function VideoButton(props) {

  const [videoModalIsOpen, setVideoModalIsOpen] = useState(false);

  return (
    <div className="video-button mb-3">
      <Button variant="text" color="primary" onClick={() => setVideoModalIsOpen(true)}>
        <SvgIcon component={PlayVideoIcon} className="icon" fontSize="large" />{props.title}
      </Button>
      <VideoModal title={props.title} link={props.link} show={videoModalIsOpen} onHide={() => setVideoModalIsOpen(false)} />
    </div>
  );
}

VideoButton.propTypes = {
  title: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/LandingPages/ProductSpecifications/VideoButton/VideoButton.js